export default __webpack_public_path__ + "static/media/treat-yourself-1024w.dcd559f6.webp";